var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1798_40828)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46084 1.33664C5.92467 1.10474 6.47803 0.832031 7.50016 0.832031C8.52225 0.832031 9.07566 1.10471 9.5395 1.33661L9.55275 1.34326C9.91575 1.52479 10.1967 1.66529 10.8335 1.66531C11.8644 1.66535 12.475 1.28096 12.6786 1.12796C12.9955 0.889798 13.3699 0.909881 13.6284 1.02945C13.8902 1.15056 14.1668 1.43952 14.1668 1.8666V10.832H16.6668C18.047 10.832 19.1668 11.9499 19.1668 13.3312V15.832C19.1668 16.6029 18.9717 17.2364 18.6362 17.7396C18.3042 18.2376 17.8675 18.5592 17.4562 18.7649C17.0481 18.9689 16.6501 19.0668 16.3611 19.1149C16.1876 19.1439 16.0098 19.1657 15.8335 19.1654H4.16683C3.39601 19.1654 2.7625 18.9703 2.25926 18.6348C1.76125 18.3028 1.43965 17.866 1.23397 17.4547C1.02993 17.0466 0.932054 16.6486 0.883896 16.3597C0.859488 16.2132 0.846963 16.0894 0.840496 15.9989C0.835113 15.9234 0.833521 15.8788 0.833496 15.832V1.86658C0.833496 1.43952 1.11003 1.15056 1.37188 1.02945C1.6304 0.909873 2.00484 0.88979 2.32174 1.12794C2.52532 1.28093 3.1359 1.66531 4.16683 1.66531C4.80362 1.66531 5.08456 1.52481 5.44756 1.34328L5.46084 1.33664ZM2.50293 15.832L2.50016 3.06846C2.95031 3.22017 3.50626 3.33197 4.16683 3.33197C5.18896 3.33197 5.74232 3.05927 6.20615 2.82737L6.21943 2.82073C6.58243 2.6392 6.86337 2.4987 7.50016 2.4987C8.13697 2.4987 8.41791 2.63919 8.78091 2.82072L8.79416 2.82736C9.258 3.05925 9.81133 3.33195 10.8335 3.33197C11.4941 3.332 12.05 3.22021 12.5002 3.06847V15.832C12.5002 16.4845 12.64 17.0387 12.8864 17.4987H4.16683C3.68765 17.4987 3.38366 17.3813 3.18377 17.248C2.97865 17.1113 2.8315 16.923 2.72469 16.7094C2.61623 16.4924 2.55785 16.2654 2.52789 16.0857C2.5138 16.0011 2.50526 15.9174 2.50293 15.832ZM16.0872 17.4709C16.2669 17.441 16.4939 17.3826 16.7108 17.2742C16.9245 17.1674 17.1127 17.0202 17.2495 16.8151C17.3827 16.6152 17.5002 16.3112 17.5002 15.832V13.3312C17.5002 12.8715 17.1276 12.4987 16.6668 12.4987H14.1668V15.832C14.1668 16.3112 14.2842 16.6152 14.4175 16.8151C14.5542 17.0202 14.7425 17.1674 14.9562 17.2742C15.1731 17.3826 15.4001 17.441 15.5799 17.4709C15.6678 17.4856 15.7392 17.4926 15.7854 17.4959C15.8859 17.5031 15.9882 17.4874 16.0872 17.4709Z",
    fill: "url(#paint0_linear_1798_40828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 6.66536C4.1665 6.20513 4.5396 5.83203 4.99984 5.83203H9.99984C10.4601 5.83203 10.8332 6.20513 10.8332 6.66536C10.8332 7.12561 10.4601 7.4987 9.99984 7.4987H4.99984C4.5396 7.4987 4.1665 7.12561 4.1665 6.66536Z",
    fill: "url(#paint1_linear_1798_40828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 10.0013C4.1665 9.54105 4.5396 9.16797 4.99984 9.16797H9.99984C10.4601 9.16797 10.8332 9.54105 10.8332 10.0013C10.8332 10.4616 10.4601 10.8346 9.99984 10.8346H4.99984C4.5396 10.8346 4.1665 10.4616 4.1665 10.0013Z",
    fill: "url(#paint2_linear_1798_40828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 13.3333C4.1665 12.8731 4.5396 12.5 4.99984 12.5H9.99984C10.4601 12.5 10.8332 12.8731 10.8332 13.3333C10.8332 13.7936 10.4601 14.1667 9.99984 14.1667H4.99984C4.5396 14.1667 4.1665 13.7936 4.1665 13.3333Z",
    fill: "url(#paint3_linear_1798_40828)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40828",
    x1: 10.0002,
    y1: 0.832031,
    x2: 10.0002,
    y2: 19.1654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40828",
    x1: 7.49984,
    y1: 5.83203,
    x2: 7.49984,
    y2: 7.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40828",
    x1: 7.49984,
    y1: 9.16797,
    x2: 7.49984,
    y2: 10.8346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1798_40828",
    x1: 7.49984,
    y1: 12.5,
    x2: 7.49984,
    y2: 14.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4DA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1798_40828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesIcon);
export default __webpack_public_path__ + "static/media/invoices-icon.dd257e98d630e5979afdb2843a2c873f.svg";
export { ForwardRef as ReactComponent };